import { useEffect, useState } from "react";
import axios from "axios";
import { useDataContext } from "../Context/dataContext";

const useBonusPrice = (accessToken) => {
  const { url } = useDataContext();
  const [aux, setAux] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBonusPrice = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${url}/AuxVariables`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setAux(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchBonusPrice();
  }, [accessToken, url]);

  return { aux, loading, error };
};

export {useBonusPrice};
